<template>
  <div :class="`dot dot--${status}`"></div>
</template>

<script>
export default {
  props : {
    status: {
      type: String,
      required: true
    }
  }
}
</script>
